import React from "react";
import { ScrollText, User } from "lucide-react";

// Collapsible tray of items whose dates couldn't be placed on the ribbon (e.g. "legendary").
export const UndatedTray = ({ items, onSelect }) => (
  <div
    className="px-5 py-2.5 flex items-center gap-2 flex-wrap border-b border-[#14140f]/8 bg-[#f5f4f0]"
    data-testid="timeline-undated-tray"
  >
    {items.map((it) => (
      <button
        key={it.id}
        data-testid={`timeline-item-${it.id}`}
        onClick={() => onSelect(it.id)}
        className="flex items-center gap-1.5 bg-white rounded-full border border-[#14140f]/10 px-3 py-1 text-xs text-[#14140f] hover:border-[#ff7360] transition-colors"
      >
        {it.type === "text" ? <ScrollText className="w-3 h-3" /> : <User className="w-3 h-3" />}
        <span className="font-serif">{it.label}</span>
        <span className="text-[#4e6073]">· {it.year_display}</span>
      </button>
    ))}
  </div>
);
